import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    activeMenu: 'home',
    showPicE:false,
    showPicC:true
  },
  mutations: {
    editMenu: (state, data) => {
      state.activeMenu = data;      
    },
    changeLangue: (state) => {
      state.showPicE = !state.showPicE;
      state.showPicC = !state.showPicC;
    }
  },
  actions: {},
  modules: {}
});